import { getPersonioAttendanceTypeIcon, Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { SegmentedControl } from "@msuite/ui/segmented-control";
import { getColorByString } from "@msuite/utils/colors";

export type AttendanceTypeFilter = "all" | "work" | "break";

/** Props Interface */
interface UserAttendanceTypePickerProps {
	value: AttendanceTypeFilter;
	onChange: (value: AttendanceTypeFilter) => void;
}

export function UserAttendanceTypePicker({ value, onChange }: UserAttendanceTypePickerProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	return (
		<SegmentedControl
			value={value}
			items={[
				{
					label: t("general.all"),
					value: "all",
					cyId: "attendance-picker-all",
					leftIcon: <Icon name="GalleryVerticalEnd" />,
				},
				{
					label: t("users.attendance_type.work"),
					value: "work",
					cyId: "attendance-picker-work",
					leftIcon: (
						<Icon
							name={getPersonioAttendanceTypeIcon("work")}
							stroke={`var(--color-${getColorByString("work")}-500`}
						/>
					),
				},
				{
					label: t("users.attendance_type.break"),
					value: "break",
					cyId: "attendance-picker-break",
					leftIcon: (
						<Icon
							name={getPersonioAttendanceTypeIcon("break")}
							stroke={`var(--color-${getColorByString("break")}-500`}
						/>
					),
				},
			]}
			onChange={(v) => onChange(v as AttendanceTypeFilter)}
		/>
	);
}
